import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, ListChecks, CalendarRange, Users, BarChart3, Settings, ChevronLeft, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';

const LOGO_URL = "https://customer-assets-wrfwihn1.emergentagent.net/job_c76a0c90-286b-4e83-9256-4f0bfd3bd86b/artifacts/f4cd7e71b5bcf638_solar%20technology%20logo.jpg";

const navItems = [
  { label: 'Dashboard', icon: LayoutDashboard, path: '/dashboard' },
  { label: 'Inquiries', icon: ListChecks, path: '/inquiries' },
  { label: 'Projects', icon: CalendarRange, path: '/projects' },
  { label: 'Customers', icon: Users, path: '/customers' },
  { label: 'Finance & Loans', icon: BarChart3, path: '/finance' },
  { label: 'Team', icon: Users, path: '/team' },
];

const Sidebar = ({ collapsed, onToggle }) => {
  return (
    <motion.aside
      initial={{ width: collapsed ? 80 : 288 }}
      animate={{ width: collapsed ? 80 : 288 }}
      transition={{ duration: 0.22, ease: [0.2, 0.0, 0, 1] }}
      className="bg-card border-r border-border flex flex-col h-full"
      data-testid="sidebar"
    >
      <div className="p-4 border-b border-border flex items-center justify-between">
        {!collapsed && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.1 }}
            className="flex items-center gap-3"
          >
            <img 
              src={LOGO_URL} 
              alt="Solar Technology" 
              className="w-10 h-10 object-contain"
            />
            <div>
              <h1 className="text-base font-semibold tracking-tight">Solar Technology</h1>
              <p className="text-xs text-muted-foreground">By Kanji Jadav</p>
            </div>
          </motion.div>
        )}
        {collapsed && (
          <img 
            src={LOGO_URL} 
            alt="Solar Technology" 
            className="w-10 h-10 object-contain mx-auto"
          />
        )}
      </div>

      <nav className="flex-1 p-3 space-y-1" data-testid="sidebar-nav">
        {navItems.map((item, idx) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) =>
              `flex items-center gap-3 h-10 px-3 rounded-md text-sm font-medium transition-all duration-200 ${isActive
                ? 'bg-accent text-foreground shadow-sm'
                : 'text-foreground/80 hover:text-foreground hover:bg-accent/50'
              }`
            }
            data-testid={`nav-${item.label.toLowerCase()}`}
          >
            <item.icon className="w-5 h-5 flex-shrink-0" />
            {!collapsed && (
              <motion.span
                initial={{ opacity: 0, x: -8 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: idx * 0.02, duration: 0.22 }}
              >
                {item.label}
              </motion.span>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="p-3 border-t border-border">
        <button
          onClick={onToggle}
          className="w-full flex items-center justify-center gap-2 h-10 px-3 rounded-md text-sm font-medium text-foreground/80 hover:text-foreground hover:bg-accent transition-colors"
          data-testid="sidebar-toggle"
        >
          {collapsed ? <ChevronRight className="w-5 h-5" /> : <ChevronLeft className="w-5 h-5" />}
          {!collapsed && <span>Collapse</span>}
        </button>
      </div>
    </motion.aside>
  );
};

export default Sidebar;
